export const STARTED_LOADING_STORY_ITEMS_FOR_GUIDE = 'STARTED_LOADING_STORY_ITEMS_FOR_GUIDE';
export const FAILED_LOADING_STORY_ITEMS_FOR_GUIDE = 'FAILED_LOADING_STORY_ITEMS_FOR_GUIDE';
export const SUCCESS_LOADING_STORY_ITEMS_FOR_GUIDE = 'SUCCESS_LOADING_STORY_ITEMS_FOR_GUIDE';
export const STARTED_SAVING_STORY_ITEMS = 'STARTED_SAVING_STORY_ITEMS';
export const FAILED_SAVING_STORY_ITEMS = 'FAILED_SAVING_STORY_ITEMS';
export const SUCCESS_SAVING_STORY_ITEMS = 'SUCCESS_SAVING_STORY_ITEMS';
